/**
 * Parses a comma-separated string into an array of strings.
 *
 * @param {string} [commaSeparated] - The input string containing comma-separated values.
 * @return {readonly string[] | undefined} - Returns an array of strings if the input is non-empty; otherwise, returns undefined.
 */
export const parseArray = (commaSeparated?: string): readonly string[] | undefined => {
  if (!commaSeparated) {
    return undefined;
  }

  return commaSeparated.split(',');
};
